import VectorTileSource from '../source/vector_tile_source';
import browser from '../util/browser';
import {cacheEntryPossiblyAdded} from '../util/tile_request_cache';

class MBTilesVectorSource extends VectorTileSource {
    constructor(id, options, dispatcher, eventedParent) {
        super(id, options, dispatcher, eventedParent);
        this.type = "mbtiles_vector";
        this.db = this.openDatabase(options.path,options.name);
    }

    openDatabase(dbPath,name) {
        if ('sqlitePlugin' in self) {
            return this.copyDatabaseFile(dbPath,name).then(function () {
                return sqlitePlugin.openDatabase({name: name, location: 'default'});
            });
        } else {
            return Promise.reject(new Error("cordova-sqlite-evcore-extbuild-free plugin not available. " +
                "Please install the plugin and make sure this code is run after onDeviceReady event"));
        }
    }

    copyDatabaseFile(dbPath,dbName) {
        const sourceFileName = cordova.file.externalRootDirectory + dbPath;   
        // const sourceFileName = cordova.file.applicationDirectory + 'www/data/' + dbName;

        if(!('device' in self)) {
            return Promise.reject(new Error("cordova-plugin-device not available. " +
                "Please install the plugin and make sure this code is run after onDeviceReady event"));
        }

        return Promise.all([
            new Promise(function (resolve, reject) {
                resolveLocalFileSystemURL(sourceFileName, resolve, reject);
            }),
            new Promise(function (resolve, reject) {
                if(device.platform === 'Android') {
                    resolveLocalFileSystemURL(cordova.file.applicationStorageDirectory, function (dir) {
                        dir.getDirectory('databases', {create: true}, function (subdir) {
                            resolve(subdir);
                        });
                    }, reject);
                } 
                else {
                    reject("Platform not supported");
                }
            })
        ]).then(function (files) {
            const sourceFile = files[0];
            const targetDir = files[1];
            return new Promise(function (resolve, reject) {
                targetDir.getFile(dbName, {}, resolve, reject);
            }).catch(function () {
                console.log("Copying database to application storage directory");
                return new Promise(function (resolve, reject) {
                    sourceFile.copyTo(targetDir, dbName, resolve, reject);
                }).then(function () {
                    console.log("Database copied");
                });
            });
        });
    }

    readTile(z, x, y, callback) {
        const query = 'SELECT BASE64(tile_data) AS base64_tile_data FROM tiles WHERE zoom_level=? AND tile_column=? AND tile_row=?';
        const params = [z, x, y];
        this.db.then(function(db) {
            db.transaction(function (txn) {
                txn.executeSql(query, params, function (tx, res) {
                    let base64Data = res.rows.length ? res.rows.item(0).base64_tile_data : undefined;
                    //console.log(base64Data)
                    //base64Data = "data:image/jpeg;base64," + base64Data
                    callback(undefined, base64Data); // Tile contents read, callback success.
                });
            }, function (error) {
                callback(error); // Error executing SQL
            });
        }).catch(function(err) {
            callback(err);
        });
    }

    loadTile(tile, callback) {
        const z = Math.min(tile.tileID.canonical.z, this.maxzoom || tile.tileID.canonical.z); // Don't try to get data over maxzoom
        const x = tile.tileID.canonical.x;
        const y = Math.pow(2,z)-tile.tileID.canonical.y-1; // Tiles on database are tms (inverted y axis)

        this.readTile(z, x, y, dispatch.bind(this));
        
        function dispatch(err, base64Data) {
            if (err) {
                return callback(err);
            }
            if(!base64Data) return;
            const params = {
                base64Data: base64Data,
                uid: tile.uid,
                tileID: tile.tileID,
                zoom: tile.tileID.overscaledZ,
                tileSize: this.tileSize * tile.tileID.overscaleFactor(),
                type: this.type,
                source: this.id,
                pixelRatio: browser.devicePixelRatio,
                showCollisionBoxes: this.map.showCollisionBoxes,
                promoteId: this.promoteId
            };
            if (!tile.actor || tile.state === 'expired') {
                tile.actor = this.dispatcher.getActor();
                tile.request = tile.actor.send('loadTile', params, done.bind(this));
            } else if (tile.state === 'loading') {
                // schedule tile reloading after it has been loaded
                tile.reloadCallback = callback;
            } else {
                tile.request = tile.actor.send('reloadTile', params, done.bind(this));
            }

            function done(err, data) {
                delete tile.request;

                if (tile.aborted)
                    return callback(null);

                if (err && err.status !== 404) {
                    return callback(err);
                }

                if (data && data.resourceTiming)
                    tile.resourceTiming = data.resourceTiming;

                if (this.map._refreshExpiredTiles && data) tile.setExpiryData(data);
                tile.loadVectorData(data, this.map.painter);

                cacheEntryPossiblyAdded(this.dispatcher);

                callback(null);

                if (tile.reloadCallback) {
                    this.loadTile(tile, tile.reloadCallback);
                    tile.reloadCallback = null;
                }
            }
        }
    }
}

export default MBTilesVectorSource;
